import { packageTypes, receivingRegions } from "../../../data/static-data"

const Inputs = ({
    regionID,
    setRegionID,
    packageType,
    setPackageType,
    senderCityWithOfficeID,
    setSenderCityWithOfficeID
}) => {
  return (
    <div className="flex gap-10">
        <div className="flex items-center gap-2">
            <h1 className="text-lg">Receiving region</h1>
            <select
                className="p-3 rounded-xl bg-white border border-gray-400"
                value={regionID}
                onChange={e => setRegionID(e.target.value)}
            >
                {receivingRegions.map(region => (
                    <option
                        key={region.value}
                        value={region.value}
                    >
                        {region.text}
                    </option>
                ))}
            </select>
        </div>
        <div className="flex items-center gap-2">
            <h1 className="text-lg">Office</h1>
            <select
                className="p-3 rounded-xl bg-white border border-gray-400"
                value={senderCityWithOfficeID}
                onChange={e => setSenderCityWithOfficeID(e.target.value)}
            >
                    <option
                        value={1}
                    >
                        Istanbul
                    </option>
                    <option
                        value={2}
                    >
                        Antalya
                    </option>
            </select>
        </div>

        <div className="flex items-center gap-2">
            <h1 className="text-lg">Package type</h1>
            <select
                className="p-3 rounded-xl bg-white border border-gray-400"
                value={packageType}
                onChange={e => setPackageType(e.target.value)}
            >
                {packageTypes.map(packageType => (
                    <option
                        value={packageType.value}
                        key={packageType.value}
                    >
                        {packageType.text.tr}
                    </option>
                ))}
            </select>
        </div>

    </div>
  )
}

export default Inputs